import { atom } from 'jotai';

export const currentPlaybackTimeAtom = atom(0);
currentPlaybackTimeAtom.debugLabel = 'currentPlaybackTime';

export const currentPlaybackItemDurationAtom = atom(0);
currentPlaybackItemDurationAtom.debugLabel = 'currentPlaybackItemDuration';

export const videoIsPlayingAtom = atom(false);
videoIsPlayingAtom.debugLabel = 'videoIsPlaying';

export const videoIsPausedAtom = atom(false);
videoIsPausedAtom.debugLabel = 'videoIsPaused';

export const videoCanPlayAtom = atom(false);
videoCanPlayAtom.debugLabel = 'videoCanPlay';

export const videoIsMutedAtom = atom(true);
videoIsMutedAtom.debugLabel = 'videoIsMuted';

export const videoVolumeAtom = atom(0);
videoVolumeAtom.debugLabel = 'videoVolume';
